import * as S from './styled'

export type Props = {
  className?: string
  fill?: string
  height?: number
  icon: string
  width?: number
  onClick?: () => void
}

export function Icon({
  icon,
  className = '',
  fill = '#000',
  height = 48,
  width = 48,
  onClick
}: Props) {
  return (
    <S.Icon
      beforeInjection={svg => {
        if (fill !== '#000') svg.setAttribute('fill', fill)
        else svg.setAttribute('style', `height: ${height}px; width: ${width}px`)
      }}
      className={className}
      renumerateIRIElements={false}
      fallback={() => null}
      height={height}
      onClick={onClick}
      preserveAspectRatio="xMidYMid meet"
      src={`/icons/${icon}.svg`}
      width={width}
    />
  )
}
